import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { DriversData, DriverResult } from '../tool-content.model';

/**
 * Renders key driver importance results as horizontal bars with explanations.
 */
@Component({
  selector: 'app-ai-drivers',
  imports: [TranslocoModule],
  templateUrl: './ai-drivers.component.html',
  styleUrls: ['./ai-drivers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiDriversComponent {
  readonly data = input.required<DriversData>();

  protected readonly title = computed(() => this.data().title);
  protected readonly target = computed(() => this.data().target);
  protected readonly drivers = computed(() => this.data().drivers);
  protected readonly hasDrivers = computed(() => this.drivers().length > 0);
  protected readonly maxImportance = computed(() => {
    const max = Math.max(...this.drivers().map((d) => d.importance), 0);
    return max > 0 ? max : 1;
  });

  protected barWidth(driver: DriverResult): number {
    return Math.round((driver.importance / this.maxImportance()) * 100);
  }

  protected barClass(driver: DriverResult): string {
    switch (driver.direction) {
      case 'positive':
        return 'ai-drivers__bar--positive';
      case 'negative':
        return 'ai-drivers__bar--negative';
      default:
        return 'ai-drivers__bar--neutral';
    }
  }

  protected formatImportance(value: number): string {
    return (value * 100).toFixed(0) + '%';
  }
}
